module.exports = __webpack_public_path__ + "static/logo-59844b14082e8696c2b3f3ec46ade5f0.png";